// Конфигурация акции
const NOW = new Date();
const END_DATE = new Date();
END_DATE.setDate(NOW.getDate() + 7); // Акция на 7 дней от момента запуска (или билда)

// Или жестко задать дату в будущем
// const FIXED_END_DATE = new Date('2026-02-01T23:59:59').getTime();

export const PROMO_CONFIG = {
    isActive: true,
    bonusPercent: 30, // 30%
    // Используем фиксированную дату, чтобы она была одинаковой для всех
    // Например, до 1 февраля 2026 года (если у вас сейчас 2026)
    endDate: new Date('2026-01-25T23:59:59').getTime(),
};

// Функция теперь может принимать текущее время сервера (чтобы избежать рассинхронизации)
export function isPromoActive(userCreatedAt?: Date, currentTimeMs?: number) {
    if (!PROMO_CONFIG.isActive) return false;
    
    const now = currentTimeMs || Date.now();

    // Если дата окончания акции в конфиге еще не наступила (старое поведение)
    if (now < PROMO_CONFIG.endDate) {
        return true;
    }

    // Новое поведение: проверяем, прошла ли неделя с момента регистрации пользователя
    if (userCreatedAt) {
        const userRegistrationTime = new Date(userCreatedAt).getTime();
        const oneWeekInMs = 7 * 24 * 60 * 60 * 1000;
        
        if (now < userRegistrationTime + oneWeekInMs) {
            return true;
        }
    }

    return false;
}

export function getPromoEndDate(userCreatedAt?: Date, currentTimeMs?: number): number | null {
    if (!PROMO_CONFIG.isActive) return null;
    
    const now = currentTimeMs || Date.now();

    // Если глобальная акция еще активна
    if (now < PROMO_CONFIG.endDate) {
        return PROMO_CONFIG.endDate;
    }
    
    // Если активна акция для нового пользователя (1 неделя)
    if (userCreatedAt) {
        const userRegistrationTime = new Date(userCreatedAt).getTime();
        const oneWeekInMs = 7 * 24 * 60 * 60 * 1000;
        const userPromoEndDate = userRegistrationTime + oneWeekInMs;
        
        if (now < userPromoEndDate) {
            return userPromoEndDate;
        }
    }
    
    return null;
}

export function calculateBonus(amount: number, userCreatedAt?: Date, currentTimeMs?: number) {
    if (!isPromoActive(userCreatedAt, currentTimeMs)) return 0;
    return Math.floor(amount * (PROMO_CONFIG.bonusPercent / 100));
}